var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { CredentialsService } from '../../services/credentials.service';
import { HasSubscriptions } from '../../components/has-subscriptions';
var ShowAuthedDirective = /** @class */ (function (_super) {
    __extends(ShowAuthedDirective, _super);
    function ShowAuthedDirective(templateRef, credentialsService, viewContainer) {
        var _this = _super.call(this) || this;
        _this.templateRef = templateRef;
        _this.credentialsService = credentialsService;
        _this.viewContainer = viewContainer;
        _this.condition = false;
        return _this;
    }
    ShowAuthedDirective.prototype.ngOnInit = function () {
        var _this = this;
        this.addSub(this.credentialsService.isLoggedIn.subscribe(function (isAuthenticated) {
            if (isAuthenticated && _this.condition || !isAuthenticated && !_this.condition) {
                _this.viewContainer.clear();
                _this.viewContainer.createEmbeddedView(_this.templateRef);
            }
            else {
                _this.viewContainer.clear();
            }
        }));
    };
    Object.defineProperty(ShowAuthedDirective.prototype, "appShowAuthed", {
        set: function (condition) {
            this.condition = condition;
        },
        enumerable: true,
        configurable: true
    });
    return ShowAuthedDirective;
}(HasSubscriptions));
export { ShowAuthedDirective };
